import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { concatMap, first, mergeMap } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { BaseWizardComponent } from '../base-wizard.component';
import { DeclarationsDataModel, IDeclarationsDataModel } from '../models/veg-wizard-models';
import { DeclarationsService } from '../services/declarations.service';
import { Logger } from '../services/logger-service';
import { GlobalValidationMessageComponent } from 'src/app/shared/global-validation-message/global-validation-message.component';
import { UtilService } from '../services/util.service';
import { VegWizardDataService } from '../services/veg-wizard-data.service';
@UntilDestroy()
@Component({
  selector: 'app-declarations',
  templateUrl: './declarations.component.html',
  styleUrls: ['./declarations.component.css'],
  imports: [
    CommonModule,   
    ReactiveFormsModule,
    GlobalValidationMessageComponent
  ],
})
export class DeclarationsComponent extends BaseWizardComponent implements OnInit {

  form: FormGroup;

  get acceptedDeclarationControl() { return this.form.controls['acceptedDeclaration']; }

  declarationsData: IDeclarationsDataModel;
  isValidAcceptedDeclaration = false;
  nextButtonClicked = false;

  constructor(
    private formBuilder: FormBuilder,
    private vwds: VegWizardDataService,
    private declarationsService: DeclarationsService,
    private sessionService: SessionService,
    private utilService: UtilService,
    private logger: Logger,
    router: Router) {
    super();

    this.declarationsData = this.vwds.getDeclarations() ?? new DeclarationsDataModel();

    this.form = this.formBuilder.group({
      acceptedDeclaration: [this.declarationsData?.acceptedDeclaration, Validators.required]
    });
  }

  ngOnInit(): void {
    this.performValidations();

    this.acceptedDeclarationControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.performValidations();
      });
  }

  performValidations() {
    this.acceptedDeclarationControl?.setErrors(null);

    this.declarationsData.acceptedDeclaration = this.acceptedDeclarationControl.value;
    this.isValidAcceptedDeclaration = this.form.valid && !!this.declarationsData.acceptedDeclaration;

    if (!this.isValidAcceptedDeclaration) {
      this.acceptedDeclarationControl?.setErrors({ 'acceptedDeclaration Required valid': true });
    }
  }

  override next() {
    this.nextButtonClicked = true;
    this.form.markAsDirty();
    this.form.updateValueAndValidity;
    this.performValidations();

    if (this.form.invalid) {
      this.utilService.getFormValidationErrors(this.form);
      return;
    }

    this.declarationsData.acceptedPrivacyStatement = this.declarationsData.acceptedDeclaration;
    const sessionId = this.sessionService.getSessionIdOrError();
    
    this.vwds
      .setDeclarationsData$(this.declarationsData)
      .pipe(first(), untilDestroyed(this)
        , concatMap(() => this.declarationsService.finalizeNotification$(sessionId)
          .pipe(mergeMap(response => this.vwds.setFinalizeNotificationReferenceNumber$(response.notificationReferenceNumber))
          )
        )
      )
      .subscribe((success) => {
        if (success) {
          super.next();
        }
        else{
          this.logger.warning("Declaration Error going to the next page....")
        }
      });      
  }
}
